<template>
  <div>
    <v-menu :disabled="disabled"
      v-model="menu" :close-on-content-click="false"
      transition="scale-transition" min-width="290px">
      <template v-slot:activator="{ on }">
        <v-text-field dense class="menu-text-field" :disabled="disabled" :label="label"
          v-model="textValue" :rules="rules && rules.map(k => rules[k])" readonly v-on="on"
          prepend-inner-icon="event" :outlined="!noOutlined" clearable>
        </v-text-field>
      </template>
      <v-date-picker dense :disabled="disabled"
        v-model="value" no-title
        :rules="rules && rules.map(k => rules[k])"
        @input="menu = false" @change='onChange'>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { format, parseISO } from 'date-fns'

@Component
export default class DateTextField extends Vue {
  @Prop(String) label
  @Prop(Boolean) disabled
  @Prop(Array) rules
  @Prop(Boolean) noOutlined
  @Prop(String) model

  menu = false
  value = null
  textValue = null

  mouned () {
    this.value = this.model
  }

  onChange (val) {
    this.textValue = format(parseISO(val), 'dd/MM/yyyy')
    this.$emit('update:model', val)
  }
}
</script>
